import styled from "styled-components";
import P from "./P";

const Span = styled(P).attrs({
  as: "span",
})`
  font-size: ${({ size, theme }) => size || theme.fontSizes.span};
  transform: ${({ transform }) => transform || "none"};
  line-height: ${({ lineHeight, theme }) => lineHeight || theme.lineHeights.normal};
`;

export default Span;
